import axios from 'axios';
import { loginRequest, loginRequest_api } from "../authConfig";

export const getApiToken = async (msalInstance, accounts) => {
    if (!msalInstance || !accounts || accounts.length === 0) {
        return null;
    }

    try {
        const account = accounts[0];
        if (account) {
            // Try to acquire token silently
            var token = msalInstance.acquireTokenSilent({
                ...loginRequest_api,
                account: account
            }).then(response => {
                console.log('successfully acquired token silently');
                return response.accessToken;
            }).catch(function (error) {
                console.error('Error Token' + error);
              var result = msalInstance.acquireTokenRedirect({
                    ...loginRequest_api,
                    account: accounts[0]
                }).then(interactiveResponse => {
                    console.log('successfully acquired token interactively');
                    if (interactiveResponse) {
                        return interactiveResponse.accessToken;
                    }
                })
                return result;
            });
            return token

        }
    } catch (error) {

        console.error('Interactive token acquisition failed:', error);
        throw error;


    }
    return null;
};

export const loginRedirect = async (msalInstance, accounts) => {
    if (!msalInstance) {
        throw new Error('MSAL instance is required');
    }

    try {
        console.log('Initiating login redirect...' + JSON.stringify(loginRequest));
        await msalInstance.loginRedirect(loginRequest);
        // Note: After redirect, the page will reload, so the code below won't execute
        // Token acquisition should be handled after the redirect completes
    } catch (error) {
        console.error('Login redirect error:', error);
        throw error;
    }
};
export const logout = async (msalInstance) => {
    if (!msalInstance) {
        throw new Error('MSAL instance is required');
    }

    try {
        const activeAccount = msalInstance.getActiveAccount();
        await msalInstance.logoutRedirect({
            account: activeAccount
        });
    } catch (error) {
        console.error('Logout error:', error);
        throw error;
    }
};

export const getPermissions = async (msalInstance, accounts, updateUserInfo = null) => {
    // Implement your permission fetching logic here
    // This is a placeholder - adjust according to your API
    try {
        const token = await getApiToken(msalInstance, accounts);
        if (token) {

            const response = await axios.get(`${process.env.REACT_APP_serverEndpoint}/User/GetPermissions`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (response.data.success) {
                const resultSet = response.data.result_set;

                // Update localStorage (fallback for components that don't use context yet)
                localStorage.setItem('permissions', JSON.stringify(resultSet?.permissions || []));
                localStorage.setItem('roles', JSON.stringify(resultSet?.roles || []));
                localStorage.setItem('traininggroupId', JSON.stringify(resultSet?.traininggroupId));
                localStorage.setItem('traininggroupName', JSON.stringify(resultSet?.traininggroupName));
                localStorage.setItem('logo', resultSet?.logo || '');
                localStorage.setItem('tenants', JSON.stringify(resultSet?.tenants || []));
                localStorage.setItem('selectedTenant', resultSet.selectedTenant);
                localStorage.setItem('navigation', JSON.stringify(resultSet?.navigation || []));

                // Update context if provided
                if (updateUserInfo) {
                    updateUserInfo({
                        logo: resultSet?.logo || null,
                        tenants: resultSet?.tenants || [],
                        permissions: resultSet?.permissions || [],
                        roles: resultSet?.roles || [],
                        traininggroupId: resultSet?.traininggroupId || null,
                        traininggroupName: resultSet?.traininggroupName || null,
                        selectedTenant: resultSet?.selectedTenant || null,
                        navigation: resultSet?.navigation || []
                    });
                }

                return resultSet;

            } else {
                localStorage.setItem('permissions', "[]");
                localStorage.setItem('roles', "[]");
                localStorage.setItem('navigation', "[]");

                if (updateUserInfo) {
                    updateUserInfo({
                        permissions: [],
                        roles: [],
                        navigation: []
                    });
                }

                return null;
            }
        }
    } catch (error) {
        console.error('Get permissions error:', error);
        return null;
    }
};
